import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

// 브라우저 확장 프로그램이 주입한 스크립트의 에러가 개발 오버레이와 콘솔을 덮지 않게 걸러 낸다.
const isExtensionError = (input: unknown) => {
  const str = String((input as Error)?.stack ?? input ?? "");
  return str.includes("chrome-extension://") || str.includes("moz-extension://") || str.includes("inpage.js");
};
window.addEventListener(
  "error",
  (e) => {
    if (isExtensionError(e.filename) || isExtensionError(e.error)) e.stopImmediatePropagation();
  },
  true
);
window.addEventListener(
  "unhandledrejection",
  (e) => {
    if (isExtensionError(e.reason)) e.stopImmediatePropagation();
  },
  true
);

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
